<div class="col-md-12" style="overflow-y: auto; overflow-y: auto">
  Добавить данные
  <span (click)="open()" title="{{hint}}" style="margin-left: 10px">
     <i class="text-warning cursor-pointer ft-plus-square" style="font-size: 1.5rem" ></i>
  </span>
</div>
<ng-container *ngIf="data.length > 0">
  <div class="col-md-12">
    <app-data-grid [data]="data"
                   [columns]="columns"
                   [idGrid]="'block-' + title"
                   [isActionExternal]="true"
                   [showAddButton]="false"
                   [isFilter]="false"
                   (editItem)="open($event)"
                   (removeId)="remove($event)"
                   [canDeleteData]="true"></app-data-grid>
  </div>
</ng-container>
